import { LazyHelmet } from '../../base'

import { static_img_url } from '../Variables'

function RequestLimt({time}) {
  return (
    <div className='handlers'>
      {/* <LazyHelmet>
        <title>Request Limit Reached</title>
      </LazyHelmet> */}

      <img src={`${static_img_url}/handlers/noconnection.webp`} alt='No Connection with server. Check your internet !' className='img-fluid' />
      <div className='h6 pcolor'>{`${time.split(':')[0]} Hours : ${time.split(':')[1]} Minutes : ${time.split(':')[2]} Seconds`}</div>
    </div>
  )
}

export default RequestLimt